export default {
  icon: require('../assets/icon.png')
};